import { Observable } from 'rxjs';
import { ApiResponse } from '../common/api-response';

export abstract class PaymentsRepository {
    abstract getPayMethods(uid: string, cid: string | null): Observable<ApiResponse<any>>;
    abstract create(data: any): Observable<ApiResponse<any>>;
    abstract cancel(bill_id: string): Observable<ApiResponse<any>>;
    abstract sell_print(prefix: string, number: string): Observable<ApiResponse<any>>;
}
